module.exports = __webpack_public_path__ + "static/date-d56dcdba51bebf9f60721090bb014797.png";